import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=3b3ccef8&scoped=true&"
import script from "./ButtonAction.vue?vue&type=script&lang=ts&"
export * from "./ButtonAction.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=3b3ccef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ccef8",
  null
  
)

export default component.exports